<template>
  <div class="container">
    <!-- Priemera Grafica-->
    <section>
      <div class="head-data">
        <h6 class="title">
          {{ titleOne }}
        </h6>
      </div>
      <GraphicsOne :datos="datos" />
    </section>

    <!-- Segunda Grafica-->
    <section>
      <div class="head-data">
        <h6 class="title">
          {{ titleTwo }}
        </h6>
      </div>
      <GraphicsTwo :datos="datos" />
    </section>
    <!-- Tercera grafica -->
    <section>
      <div class="head-data">
        <h6 class="title">
          {{ titleThree }}
        </h6>
      </div>
      <GraphicsThree :datos="datos" />
    </section>
    <!-- Cuarta grafica -->
    <section>
      <div class="head-data">
        <h6 class="title">
          {{ titleFour }}
        </h6>
      </div>
      <GraphicsFour :datos="datos" />
    </section>

    <!-- Quinta grafica -->
    <section>
      <div class="head-data">
        <h6 class="title">
          {{ titleFive }}
        </h6>
      </div>
      <GraphicsFive :datos="datos" />
    </section>

    <!-- Sexta grafica -->
    <section>
      <div class="head-data">
        <h6 class="title">
          {{ titleSix }}
        </h6>
      </div>
      <GraphicSix :datos="datos" />
      <!-- <MainTable /> -->
    </section>
  </div>
</template>

<script>
import GraphicsOne from "./graphics/GraphicsOne.vue";
import GraphicsTwo from "./graphics/GraphicsTwo.vue";
import GraphicsThree from "./graphics/GraphicsThree.vue";
import GraphicsFour from "./graphics/GraphicsFour.vue";
import GraphicsFive from "./graphics/GraphicsFive.vue";
import GraphicSix from "./graphics/GraphicsSix.vue";
import { showAlert } from "../../../components/tools/utils";
// import MainTable from "./tables/MainTable";
export default {
  components: {
    GraphicsOne,
    GraphicsTwo,
    GraphicsThree,
    GraphicsFour,
    GraphicsFive,
    GraphicSix,
    // MainTable,
  },
  props: ["listData"],
  data() {
    return {
      titleOne: `Dotación efectiva año ${process.env.VUE_APP_ANIO}, por tipo de contrato (mujeres y hombres)`,
      titleTwo: `Dotación efectiva año ${process.env.VUE_APP_ANIO}, por Estamento (mujeres y hombres)`,
      titleThree: `Dotación efectiva año ${process.env.VUE_APP_ANIO}, por Grupos de Edad (mujeres y hombres)`,
      titleFour: `Personal de dotacion año ${process.env.VUE_APP_ANIO}, por tipo de contrato (mujeres y hombres)`,
      titleFive: `Personal a honorarios año ${process.env.VUE_APP_ANIO}, según función desempeñada (mujeres y hombres)`,
      titleSix: `Personal a honorarios año ${process.env.VUE_APP_ANIO}, según permanencia en el Servicio (mujeres y hombres)`,
      datos: null,
    };
  },

  mounted() {
    showAlert({
      icon: "success",
      text: "Espere un momento mientras carga los datos",
      timerProgressBar: true,
      timer: 4000,
    });

    setTimeout(() => {
      this.datos = this.listData;
    }, 5000);
  },
};
</script>

<style scoped>
.head-data {
  background-color: #cfcccc;
}
.title {
  padding: 1rem;
}
/* .container-graphics {
  display: flex;
  justify-content: center;
  align-items: center;
} */
</style>
